import { Crown, Shield, Zap } from 'lucide-react';
import type React from 'react';
import type { LicenseTier } from '@/lib/licensing/types';

export const TIER_ICONS: Record<LicenseTier, React.ReactNode> = {
  essentials: <Shield className="w-5 h-5 text-blue-400" />,
  professional: <Zap className="w-5 h-5 text-emerald-400" />,
  enterprise: <Crown className="w-5 h-5 text-amber-400" />,
};

export const TIER_COLORS: Record<LicenseTier, string> = {
  essentials: 'border-blue-500/40 bg-blue-950/30',
  professional: 'border-emerald-500/40 bg-emerald-950/30',
  enterprise: 'border-amber-500/40 bg-amber-950/30',
};

export const TIER_SELECTED: Record<LicenseTier, string> = {
  essentials: 'ring-2 ring-blue-500 border-blue-500',
  professional: 'ring-2 ring-emerald-500 border-emerald-500',
  enterprise: 'ring-2 ring-amber-500 border-amber-500',
};
